<nz-layout class="rmv_mrgn">
  <nz-layout>
    <nz-content>
      <div class="inner-content">
        @if (opnSdebar == true) {
        <button nz-button (click)="closeSidebar()" class="sdNavBtn rt-4h">
          <!-- <i nz-icon nzType="filter" nzTheme="outline"></i> -->
          Close
        </button>
        } @if (opnSdebar == false) {
        <button nz-button (click)="openSidebar()" class="sdNavBtn2 rt-40">
          <i nz-icon nzType="filter" nzTheme="outline"></i>Filters
        </button>
        }
        <div id="playbackmap">
          <div class="vhcl-sts-card">
            <ul>
              <li>
                <span
                  ><img
                    style="height: 20px; width: 20px"
                    src="/assets/images/markers/playback/startPoint.png"
                    alt=""
                /></span>
                Source
              </li>
              <li>
                <span
                  ><img
                    style="height: 20px; width: 20px"
                    src="/assets/images/markers/playback/endPoint.png"
                    alt=""
                /></span>
                Destination
              </li>
              <li>
                <span
                  ><img
                    style="height: 20px; width: 20px"
                    src="/assets/images/markers/playback/parking.png"
                    alt=""
                /></span>
                Parking
              </li>
              <li>
                <span
                  ><img
                    style="height: 20px; width: 20px"
                    src="/assets/images/markers/playback/parkingRed.png"
                    alt=""
                /></span>
                Parking more than 10 Min
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nz-content>
  </nz-layout>

  @if (opnSdebar == true) {
  <nz-sider
    nzCollapsible
    [(nzCollapsed)]="isCollapsed"
    [nzWidth]="390"
    [nzTrigger]="null"
    class="sdr"
  >
    <h2 class="sdHdr">
      Playback
      <span
        nz-icon
        nzType="close-circle"
        nzTheme="outline"
        style="float: right; margin-top: 3px"
        (click)="closedrvrlst()"
      ></span>
    </h2>
    <form nz-form [formGroup]="plyBckform">
      <div class="row mg-b6">
        @if (clntDtls[0].clnt_id==3000000) {
        <nz-form-label nzRequired>District</nz-form-label>
        } @if (clntDtls[0].clnt_id==7) {
        <nz-form-label nzRequired>Show ULB/Mandal</nz-form-label>
        } @if (clntDtls[0].clnt_id!=7 && clntDtls[0].clnt_id!=3000000 &&
        clntDtls[0].clnt_id!=3000001) {
        <nz-form-label nzRequired>Show ULB</nz-form-label>
        } @if (clntDtls[0].clnt_id==3000001) {
        <nz-form-label nzRequired>Select Zone</nz-form-label>
        }
        <!-- <div class="col-lg-4 col-md-4">
          </div> -->
        <div class="col-lg-12 col-md-12">
          <nz-form-item>
            <nz-form-control>
              <nz-select
                nzShowSearch
                class="slctBx"
                [(ngModel)]="selectedtenants"
                (ngModelChange)="getvehiclesFunctn($event)"
                [ngModelOptions]="{ standalone: true }"
              >
                @if (showAll) {
                <nz-option [nzLabel]="'Select All'" [nzValue]="0"></nz-option>
                }
                <!-- <nz-option [nzLabel]="'Deselect All'" [nzValue]="1"></nz-option> -->
                @for (t of tntLst; track t) {
                <nz-option
                  [nzValue]="t.tnt_id"
                  [nzLabel]="t.tnt_nm"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      @if (clntDtls[0].clnt_id==3000001) {
      <div class="row mg-b6">
        <nz-form-label nzRequired>Select {{ grpLbl }}</nz-form-label>
        <div class="col-lg-12 col-md-12">
          <nz-form-item>
            <nz-form-control>
              <nz-select
                nzShowSearch
                class="slctBx"
                [(ngModel)]="asrt_grp_id"
                (ngModelChange)="getAssrtGroupLists($event)"
                [ngModelOptions]="{ standalone: true }"
              >
                <nz-option [nzLabel]="'Select All'" [nzValue]="0"></nz-option>
                @for (t of assrtGroupList; track t) {
                <nz-option
                  [nzValue]="t.asrt_grp_id"
                  [nzLabel]="t.asrt_grp_nm"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      } @if (ShowClap) {
      <div class="row mg-b6">
        <nz-form-label nzRequired>Select Vehicle Vendor</nz-form-label>
        <div class="col-lg-12 col-md-12">
          <nz-form-item>
            <nz-form-control>
              <nz-select
                class="slctBx"
                nzShowSearch
                [(ngModel)]="selectedvndr"
                (ngModelChange)="onvndrSelect($event)"
                [ngModelOptions]="{ standalone: true }"
              >
                @if (!showVndr) {
                <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
                } @for (v of vendorList; track v) {
                <nz-option
                  [nzValue]="v.vndr_id"
                  [nzLabel]="v.vndr_nm"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      }
      <!-- <div class="row mg-b6">
        <nz-form-label nzRequired>Select Location</nz-form-label>
        <div class="col-lg-12 col-md-12">
          <nz-form-item>
            <nz-form-control>
              <nz-select class="slctBx" [nzMaxTagCount]="2" nzPlaceHolder="Please select Location"
                (ngModelChange)="updt($event)" formControlName="lctn">
                <nz-option [nzLabel]="'Select All'" [nzValue]="'select'"></nz-option>
                <nz-option [nzLabel]="'Deselect All'" [nzValue]="'deselect'"></nz-option>
                <nz-option *ngFor="let l of activeGroups" [nzLabel]="l.fnce_grp_nm" [nzValue]="l.fnce_grp_id">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div> -->
      <div class="row mg-b6">
        <nz-form-label nzRequired>Select Location Group</nz-form-label>
        <div class="col-lg-12 col-md-12">
          <nz-form-item>
            <nz-form-control>
              <nz-select
                [nzMaxTagCount]="2"
                nzPlaceHolder="Please select Location group"
                [(ngModel)]="locModel"
                (ngModelChange)="onLocationSelect($event)"
                formControlName="lctn"
              >
                <!-- <nz-option [nzLabel]="'Select All'" [nzValue]="'select'"></nz-option>
                <nz-option [nzLabel]="'Deselect All'" [nzValue]="'deselect'"></nz-option> -->
                @for (l of activeGroups; track l) {
                <nz-option [nzLabel]="l.fnce_grp_nm" [nzValue]="l.fnce_grp_id">
                </nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="row mg-b6">
        <nz-form-label nzRequired>Select Location</nz-form-label>
        <div class="col-lg-12 col-md-12">
          <nz-form-item>
            <nz-form-control>
              <nz-select
                [nzMaxTagCount]="2"
                nzPlaceHolder="Please select Location"
                [(ngModel)]="fnclocModel"
                (ngModelChange)="getLocOnMap()"
                formControlName="lctnFnce"
              >
                <nz-option
                  [nzLabel]="'Select All'"
                  [nzValue]="'select'"
                ></nz-option>
                <nz-option
                  [nzLabel]="'Deselect All'"
                  [nzValue]="'deselect'"
                ></nz-option>
                @for (l of fncsLst; track l) {
                <nz-option [nzLabel]="l.fnce_nm" [nzValue]="l.fnce_id">
                </nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="row mg-b6">
        <nz-form-label nzRequired>Select Vehicle</nz-form-label>
        <!-- <div class="col-lg-4 col-md-4">
        <nz-form-label nzRequired>Select Vehicle</nz-form-label>
      </div> -->
        <div class="col-lg-12 col-md-12">
          <nz-form-item>
            <nz-form-control>
              <nz-select
                class="slctBx"
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Please select Vehicle"
                formControlName="vhcl"
                (ngModelChange)="getTripsbyAsrt($event)"
              >
                @for (v of vhclsDta; track v) {
                <nz-option
                  [nzLabel]="v.asrt_nm"
                  [nzValue]="v.asrt_id"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="row mg-b6">
        <nz-form-label nzRequired>Select PlaybackType</nz-form-label>
        <!-- <div class="col-lg-4 col-md-4">
      <nz-form-label nzRequired>Select PlaybackType</nz-form-label>
    </div> -->
        <div class="col-lg-12 col-md-12">
          <nz-form-item>
            <nz-form-control>
              <nz-select
                class="slctBx"
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Please select Playback Type"
                formControlName="plybtype"
                (ngModelChange)="getPlybackType($event)"
              >
                <nz-option nzLabel="ByTrip" nzValue="1"></nz-option>
                <nz-option nzLabel="ByTime" nzValue="2"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      @if (trpdate) {
      <div class="row mg-b6">
        <nz-form-label nzRequired>Select TripDate</nz-form-label>
        <!-- <div class="col-lg-4 col-md-4">
      <nz-form-label nzRequired>Select TripDate</nz-form-label>
    </div> -->
        <div class="col-lg-12 col-md-12">
          <nz-form-item>
            <nz-form-control>
              <nz-date-picker
                formControlName="trpdt"
                (ngModelChange)="getTrpDate($event)"
              ></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      } @if (trpdtl) {
      <div class="row mg-b6">
        <nz-form-label nzRequired>Select Trip</nz-form-label>
        <!-- <div class="col-lg-4 col-md-4">
    <nz-form-label nzRequired>Select Trip</nz-form-label>
  </div> -->
        <div class="col-lg-12 col-md-12">
          <nz-form-item>
            <nz-form-control>
              <nz-select
                class="slctBx"
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Please select Trip"
                formControlName="trp"
                (ngModelChange)="getTripData($event)"
              >
                @for (t of trpDta; track t) {
                <nz-option
                  [nzLabel]="t.rte_nm"
                  [nzValue]="t.trp_rn_id"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      } @if (strtdate) {
      <div class="row mg-b6">
        <nz-form-label nzRequired>Start Date</nz-form-label>
        <!-- <div class="col-lg-4 col-md-4">
    <nz-form-label nzRequired>Start Date</nz-form-label>
  </div> -->
        <div class="col-lg-12 col-md-12">
          <nz-form-item>
            <nz-form-control>
              <nz-date-picker
                nzShowTime
                formControlName="strtTm"
              ></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      } @if (enddate) {
      <div class="row mg-b6">
        <nz-form-label nzRequired>End Date</nz-form-label>
        <!-- <div class="col-lg-4 col-md-4">
    <nz-form-label nzRequired>End Date</nz-form-label>
  </div> -->
        <div class="col-lg-12 col-md-12">
          <nz-form-item>
            <nz-form-control>
              <nz-date-picker
                nzShowTime
                formControlName="endTm"
              ></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      }
      <div class="input-row" nz-row>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="mnuprflMrgn btnGrp"
        >
          <!-- <button nz-button nzType="primary">Primary Button</button>
    <button nz-button nzType="default">Default Button</button> -->
          <button nz-button nzType="track" (click)="trackVehicle()">
            Track
          </button>
          @if (pauseVal == true) {
          <button nz-button nzType="pause" (click)="pause()">Pause</button>
          } @if (pauseVal == false) {
          <button nz-button nzType="play" (click)="play()">Play</button>
          }
        </div>
        @if (showLdr) {
        <ds-loading></ds-loading>
        }
      </div>
    </form>
    <!-- <label nz-checkbox  *ngFor="let c of cntxt"  [(ngModel)]="checked" (ngModelChange)="chckFun($event)" [nzValue]="c"   *ngIf="cntxt.length!=0">{{c.fnce_nm}}</label> -->
    <!-- <div *ngFor="let c of cntxt; let i=index"  *ngIf="cntxt.length!=0">
<label>
  <input type="checkbox" [value]="c.fnce_id" (change)="chckFun($event)" />
  {{c.fnce_nm}}
</label>
</div> -->
    <!-- <div style="border-bottom: 1px solid rgb(233, 233, 233);" *ngIf="cntxt.length!=0">
<label nz-checkbox [(ngModel)]="allChecked" [nzValue]="cntxt" (ngModelChange)="updateAllChecked($event)" [nzIndeterminate]="indeterminate">
  Check all
</label>
</div>
<br />
<nz-checkbox-group [(ngModel)]="cntxt" [nzValue]="cntxt"   (ngModelChange)="updateSingleChecked($event)"></nz-checkbox-group> -->
    <!-- <div style="text-align:center" *ngIf="cntxt.length!=0">
<h6>
  ------ Trip Coverage Areas ------
</h6>
<div class="container">
  <div class="text-center" style="margin-top: 3px;">
    <div class="row">
      <ul class="list-group">
        <li class="list-group-item">
          <span>
            Select/ Unselect All
          </span>
          <span>
            <input type="checkbox" [(ngModel)]="masterSelected" name="list_name" value="m1"
              (change)="checkUncheckAll()" />
            </span>
          </li>
        </ul>
        <ul class="list-group">
          <li class="list-group-item" *ngFor="let item of checklist">
            <span>
              {{item.value}}
            </span>
            <span>
              <input type="checkbox" [(ngModel)]="item.isSelected" name="list_name" value="{{item.id}}"
                (change)="isAllSelected()" />
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div> -->
    @if (shwSpdMtr == true) {
    <div class="input-row plyBck" nz-row>
      <div
        nz-col
        nzXs="24"
        nzSm="24"
        nzMd="24"
        nzLg="24"
        nzXl="24"
        class="mnuprflMrgn sliderCrd"
      >
        <div
          style="
            display: flex;
            flex-direction: column;
            gap: 8px;
            align-items: center;
            padding: 8px 12px;
            border-radius: 12px;
            background: #fff;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
          "
        >
          <div style="font-weight: 600">
            {{
              sliderValue <= 100
                ? 1
                : sliderValue <= 150
                ? 1.5
                : sliderValue <= 200
                ? 2.0
                : 3.0
            }}x
          </div>
          <div
            style="display: flex; align-items: center; gap: 10px; width: 100%"
          >
            <button
              (click)="
                onSpeedChange(sliderValue > 100 ? sliderValue - 50 : 100)
              "
              style="
                background: transparent;
                border: 0;
                font-weight: 700;
                font-size: 18px;
                line-height: 1;
                padding: 0 6px;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              −
            </button>
            <nz-slider
              style="flex: 1"
              [nzMin]="100"
              [nzMax]="250"
              [nzStep]="50"
              [nzDots]="true"
              [nzTooltipVisible]="'default'"
              [(ngModel)]="sliderValue"
              (ngModelChange)="onSpeedChange($event)"
            >
            </nz-slider>
            <button
              (click)="
                onSpeedChange(sliderValue < 250 ? sliderValue + 50 : 250)
              "
              style="
                background: transparent;
                border: 0;
                font-weight: 700;
                font-size: 18px;
                line-height: 1;
                padding: 0 6px;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              +
            </button>
          </div>
          <div
            style="
              display: flex;
              gap: 8px;
              flex-wrap: wrap;
              justify-content: center;
            "
          >
            <nz-tag
              [nzColor]="sliderValue === 100 ? 'blue' : 'default'"
              (click)="onSpeedChange(100)"
              >1.0x</nz-tag
            >
            <nz-tag
              [nzColor]="sliderValue === 150 ? 'blue' : 'default'"
              (click)="onSpeedChange(150)"
              >1.5x</nz-tag
            >
            <nz-tag
              [nzColor]="sliderValue === 200 ? 'blue' : 'default'"
              (click)="onSpeedChange(200)"
              >2.0x</nz-tag
            >
            <nz-tag
              [nzColor]="sliderValue === 250 ? 'red' : 'default'"
              (click)="onSpeedChange(250)"
              >3.0x</nz-tag
            >
          </div>
        </div>
      </div>
    </div>
    } @if (shwSpdMtr == true) {
    <div class="crdTrp">
      <!-- <h6>
      ------ Target Tripwise Details ------
    </h6>
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 nopdng rgtbrdr">
        <p>{{actualTimeDisplay}}</p>
        <h2>(Actual Time)</h2>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 nopdng ">
        <p>{{totalTravelTime}}</p>
        <h2>(Travel Time)</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 nopdng rgtbrdr">
        <p>{{trackVehicleSpeed}}</p>
        <h2>(Speed)</h2>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 nopdng ">
        <p>{{travelDist}}</p>
        <h2>(Travel Distance)</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 nopdng rgtbrdr">
        <p>{{drvr_nm}}</p>
        <h2>(Driver Name)</h2>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 nopdng ">
        <p>{{drvr_mbl_nu}}</p>
        <h2>(Drive Mobile Number)</h2>
      </div>
    </div> -->
      <div class="row">
        <div class="col-md-12">
          <table class="dtlstble">
            <th>
              <div class="tblehdng">Target Tripwise Details</div>
            </th>
            <tr>
              <td>
                <p>{{ actualTimeDisplay }}</p>
                <h2>(Actual Time)</h2>
              </td>
              <td>
                <p>{{ totalTravelTime }}</p>
                <h2>(Travel Time)</h2>
              </td>
            </tr>
            <tr>
              <td>
                <p>{{ trackVehicleSpeed }}</p>
                <h2>(Speed)</h2>
              </td>
              <td>
                <p>{{ travelDist }}</p>
                <h2>(Travel Distance)</h2>
              </td>
            </tr>
            <tr>
              <td>
                <p>{{ drvr_nm }}</p>
                <h2>(Driver Name)</h2>
              </td>
              <td>
                <p>{{ drvr_mbl_nu }}</p>
                <h2>(Drive Mobile Number)</h2>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    } @if (shwprkng == true) {
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding: 0px">
      <div class="row">
        <h3 style="text-align: center; font-size: 16px">Parking Points</h3>
        <app-data-grid
          id="gridContainer"
          class="lvetracktable"
          [dataSource]="fnlParkingPoints"
          [searchPanel]="true"
          [filterRow]="false"
          [filterPanel]="false"
          [groupPanel]="false"
          [columnChooser]="false"
          [allowExport]="playbackCompleted == true ? true : false"
          [exportFileName]="ParkingPoints"
          [pageSize]="10"
          [allowedPageSizes]="[10, 25, 50, 100]"
          [showPageSizeSelector]="true"
          [rowAlternationEnabled]="true"
          [showBorders]="true"
          [wordWrapEnabled]="true"
        >
          <!-- -->
          <app-grid-column
            dataField="sno"
            caption="S.No"
            width="45"
            alignment="center"
          ></app-grid-column>
          <app-grid-column
            dataField="asrt_nm"
            caption="Vehicle"
            alignment="center"
            width="90"
          ></app-grid-column>
          <app-grid-column
            dataField="Signal"
            caption="From"
            width="45"
            alignment="center"
          ></app-grid-column>
          <app-grid-column
            dataField="lastTime"
            caption="To"
            width="45"
            alignment="center"
          ></app-grid-column>
          <app-grid-column
            dataField="stoppageTime"
            caption="Duration"
            alignment="center"
            width="45"
          ></app-grid-column>
          <app-grid-column
            dataField="lat"
            caption="Latitude"
            alignment="center"
            width="45"
          ></app-grid-column>
          <app-grid-column
            dataField="lng"
            caption="Longitude"
            alignment="center"
            width="45"
          ></app-grid-column>
        </app-data-grid>
      </div>
      <!-- <div class="row" *ngIf="showTimeline == true">
    <div class="container table-responsive">
      <table class="table table-striped header-fixed">
        <thead>
          <tr>
            <th>S.no </th>
            <th>Status</th>
            <th>Address</th>
            <th>In Time</th>
            <th>Out Time</th>
            <th>Stoppage</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let f of fencInOutDtls ; let i = index">
            <td class="filterable-cell" ng-style="{'background-color': f.cvr_sts === 1 ? '#f76767' : ''}">{{i+1}}
            </td>
            <td class="filterable-cell" *ngIf="f.fnce_cvr_sts == 1">
              <img src="assets/images/markers/mapIcons/m/dumperBin_r_m.png" class="plbckTmlneImg crsrNodrp">
            </td>
            <td class="filterable-cell" *ngIf="f.fnce_cvr_sts == 0 || f.fnce_cvr_sts == null">
              <img src="assets/images/markers/mapIcons/m/dumperBin_r_m.png" class="plbckTmlneImg crsrNodrp">
            </td>-->
      <!-- ng-click="showGarbagePointOnMap(f.fnce_id,f.lati,f.longi);" -->
      <!-- <td class="filterable-cell">{{f.fnce_nm}}</td>
            <td class="filterable-cell">{{f.actl_arvl_ts}}</td>
            <td class="filterable-cell">{{f.actl_dprte_ts}}</td>
            <td class="filterable-cell">{{f.stoppage}}</td>
          </tr>
        </tbody>
      </table>
    </div> -->
      <!-- </div>
  <div class="row" *ngIf="fencInOutDtls && fencInOutDtls.length">
    <img src="assets/images/infoMsg/location_not_found.png" class="noLctnFmdIMg" *ngIf="fencInOutDtls.length != 0">
  </div> -->
    </div>
    }
  </nz-sider>
  }
</nz-layout>

<!-- <button nz-button nzType="primary" (click)="trackVehicle()">PLAYBACK</button> -->
